import { render, staticRenderFns } from "./standart-modal.vue?vue&type=template&id=2934bb80&"
import script from "./standart-modal.vue?vue&type=script&lang=ts&"
export * from "./standart-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports